import axios from '@/plugins/axios'

export default {
  namespaced: true,

  state: {
    employees: [],
    totalEmployees: 0,
    currentEmployee: null,
    loading: false,
    error: null
  },

  mutations: {
    SET_EMPLOYEES(state, { employees, total }) {
      state.employees = employees
      state.totalEmployees = total
    },
    SET_CURRENT_EMPLOYEE(state, employee) {
      state.currentEmployee = employee
    },
    SET_LOADING(state, loading) {
      state.loading = loading
    },
    SET_ERROR(state, error) {
      state.error = error
    }
  },

  actions: {
    async fetchEmployees({ commit }, params) {
      commit('SET_LOADING', true)
      try {
        const response = await axios.get('/api/employees', { params })
        commit('SET_EMPLOYEES', {
          employees: response.data.rows,
          total: response.data.count
        })
      } catch (error) {
        commit('SET_ERROR', error.response?.data?.message || 'Failed to fetch employees')
        throw error
      } finally {
        commit('SET_LOADING', false)
      }
    },

    async fetchEmployee({ commit }, id) {
      commit('SET_LOADING', true)
      try {
        const response = await axios.get(`/api/employees/${id}`)
        commit('SET_CURRENT_EMPLOYEE', response.data)
        return response.data
      } catch (error) {
        commit('SET_ERROR', error.response?.data?.message || 'Failed to fetch employee')
        throw error
      } finally {
        commit('SET_LOADING', false)
      }
    },

    async createEmployee({ commit }, data) {
      commit('SET_LOADING', true)
      try {
        const response = await axios.post('/api/employees', data)
        return response.data
      } catch (error) {
        commit('SET_ERROR', error.response?.data?.message || 'Failed to create employee')
        throw error
      } finally {
        commit('SET_LOADING', false)
      }
    },

    async updateEmployee({ commit }, { id, data }) {
      commit('SET_LOADING', true)
      try {
        const response = await axios.put(`/api/employees/${id}`, data)
        return response.data
      } catch (error) {
        commit('SET_ERROR', error.response?.data?.message || 'Failed to update employee')
        throw error
      } finally {
        commit('SET_LOADING', false)
      }
    },

    async deleteEmployee({ commit }, id) {
      commit('SET_LOADING', true)
      try {
        await axios.delete(`/api/employees/${id}`)
      } catch (error) {
        commit('SET_ERROR', error.response?.data?.message || 'Failed to delete employee')
        throw error
      } finally {
        commit('SET_LOADING', false)
      }
    }
  },

  getters: {
    getEmployees: state => state.employees,
    getTotalEmployees: state => state.totalEmployees,
    getCurrentEmployee: state => state.currentEmployee,
    isLoading: state => state.loading,
    getError: state => state.error
  }
}
